"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
export default class Ports {
  constructor(app) {
    __publicField(this, "app");
    this.app = app;
  }
  safeSubscribe(portName, callback) {
    if (typeof this.app.ports[portName] != "undefined") {
      this.app.ports[portName].subscribe(callback);
    } else {
      console.info(
        `Elm port '${portName}' doesn't appear to be used and maybe should be deleted?`
      );
    }
  }
  safeSend(portName, value) {
    if (typeof this.app.ports[portName] != "undefined") {
      this.app.ports[portName].send(value);
    } else {
      console.info(
        `Elm port '${portName}' doesn't appear to be used and maybe should be deleted?`
      );
    }
  }
}
